import * as React from "react";
import { Box, Typography, useTheme, Container, Grid } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";

import Data from "../requests/data"

// import { postApi } from "../../../services/axiosInstance";
// import { API_PATH } from "../../../services/apipath";

const Requests = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // const acceptRequest = async () => {
  //   try {
  //     const res = await getApi(API_PATH.SUPER_ADMIN.INSTITUTE_SIGNUP);
  //     if (response.status === 200) {
  //       setRequest(response.data);
  //     }
  //   } catch (error) {
  //     console.log(error, "notaccepted");
  //   }
  // };

  // React.useEffect(() => {
  //   acceptRequest();
  // }, []);


  return (

    <Container backgroundColor={colors.primary[900]} className="border-5"
      sx={{ padding: "16px 0 17px 0" }}>

      <Grid container alignItems="center" spacing={0} sx={{
        padding: "16px", borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        borderBottomLeftRadius: '16px',
        borderBottomRightRadius: '16px',
        backgroundColor: "#ffffff"
      }}>

        <Grid item xs={12} sm={12} md={12} sx={{ backgroundColor: "#F4F7FF", borderRadius: "15px", padding: "10px" }}>
          <Box
            className="border-5"
            height={515}
            sx={{
              borderTopLeftRadius: '16px',
              borderTopRightRadius: '0px',
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '0px',
            }}
          >

            <Box
              p="0 20px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >

              <Grid container alignItems="center" spacing={0} sx={{ marginBottom: "20px" }}>
                <Grid item xs={12} sm={6} md={12}>
                  <div>
                    <Typography variant="h4" style={{ color: '#1F2A40', fontWeight: '600' }}>
                      Requests
                    </Typography>
                    <Typography variant="h6" style={{ color: '#000000' }}>
                      New Leads From Ads Form
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Box>

            <Box height="470px" m="-20px 0 0 0" sx={{ overflowY: 'scroll' }}>
              <Data />
            </Box>

          </Box>
        </Grid>
      </Grid>

    </Container >





  );
};

export default Requests;
